<script lang="ts" setup>
import type {DialogContentEmits, DialogContentProps} from "reka-ui"
import {useForwardPropsEmits} from "reka-ui"
import type {HTMLAttributes} from "vue"
import {reactiveOmit} from "@vueuse/core"
import {DrawerContent, DrawerPortal} from "vaul-vue"
import {cn} from "@/lib/utils"
import DrawerOverlay from "./DrawerOverlay.vue"

const props = withDefaults(
  defineProps<DialogContentProps & { class?: HTMLAttributes["class"]; handle?: boolean }>(),
  {handle: true},
)
const emits = defineEmits<DialogContentEmits>()

const delegatedProps = reactiveOmit(props, "class", "handle")
const forwardedProps = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerContent
      v-bind="forwardedProps" :class="cn(
        'fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950',
        props.class,
      )"
    >
      <div class="mx-auto mt-4 h-2 w-[100px] rounded-full bg-slate-100 dark:bg-slate-800" />
      <slot />
    </DrawerContent>
  </DrawerPortal>
</template>
